// Pouso após o login (REQ-FE-001): matriz 2×3 derivada só de `/me` + última escolha lembrada (REQ-FE-003).
import { Navigate } from 'react-router';

import { useMe } from '../lib/auth/authContext';
import { browserPreferenceStorage, readContextPreference } from '../lib/context/contextPreferences';
import { landingPath, resolveLanding } from '../lib/context/contextResolver';

export function LandingPage() {
  const me = useMe();
  const remembered = readContextPreference(browserPreferenceStorage(), me.user.id);
  const landing = resolveLanding(me, remembered);
  return <Navigate to={landingPath(landing)} replace />;
}
